<template>
  <div class="distribution-areas">
    <!-- Skeleton loader when data is loading -->
    <template v-if="isLoading">
      <v-skeleton-loader v-for="i in 1" :key="i" class="mb-4" type="image" />
    </template>

    <!-- Actual content when data is loaded -->
    <template v-else>
      <div class="contiainer-distubution">
        <div class="contiainer">
          <div class="right-side">
            <div v-if="!isAgents" class="title-wrapper">
              <div class="icon-backgorund">
                <v-icon color="black" icon="mdi-flag-checkered"></v-icon>
              </div>
              <span class="font-18 font-weight-bold text-start">{{
                distributionArea?.title
              }}</span>
            </div>
          </div>
        </div>
        <div class="agents">
          <div class="title-agents">
            <div
              v-if="distributionArea?.goalAgentSales"
              class="title-agents-right"
            >
              <v-icon icon="mdi-chart-bar"></v-icon>
              <span class="gray font-18">יעד</span>
              <div class="font-18 semi-bold">
                {{ distributionArea?.goalAgentSales?.toLocaleString() }} ₪
              </div>
            </div>
          </div>
          <div>
            <v-progress-linear
              v-if="distributionArea?.goalAgentSales"
              class="progress-linear"
              v-model="goalPerecntage"
              :model-value="goalPerecntage"
              color="#6d1106"
              height="17"
            >
              <strong>{{ formatPrice(goalPerecntage) }}%</strong>
            </v-progress-linear>
            <div class="align-start">
              <span class="semi-bold"
                >{{ getValueLabel(distributionArea) + " " }}
              </span>
              <span class="semi-bold">₪</span>
              <span class="semi-bold font-24">
                {{ formatPrice(distributionArea?.agentSales) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- <AgentMonthlyGoalModal
        v-if="isAgentModal"
        :openModal="isAgentModal"
        :monthlyGoal="distributionArea?.monthlyGoal"
        :agentName="distributionArea?.agentname"
        @closeModal="isAgentModal = false"
        @updateNewAgentMonthlyGoal="updateNewAgentMonthlyGoal"
      /> -->
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import AgentMonthlyGoalModal from "../UI/modals/AgentMonthlyGoalModal.vue";
import { truncateText, formatPrice } from "@/utilities.js";

export default {
  components: {
    // AgentMonthlyGoalModal,
  },
  data() {
    return {
      isAgentModal: false,
    };
  },
  computed: {
    ...mapGetters({
      getUserRole: "AuthModule/getUserRole",
    }),
    goalPerecntage() {
      const value1 = Math.ceil(this.distributionArea?.goalAgentSales);
      const value2 = Math.ceil(this.distributionArea?.agentSales);
      if (value1 === 0) return 0;
      const perectage = (value2 / value1) * 100;
      return isNaN(perectage) ? 0 : perectage;
    },
  },
  methods: {
    getValueLabel(distributionArea) {
      if (distributionArea?.title?.includes("חודשי")) {
        return "מכירות";
      } else {
        return "הוזמן";
      }
    },
    formatPrice(price) {
      return formatPrice(price);
    },
    async updateNewAgentMonthlyGoal(newMonthlyGoal) {
      try {
        const response = await this.$store.dispatch(
          "ControlPanel/updateNewAgentMonthlyGoal",
          {
            newMonthlyGoal: newMonthlyGoal,
            agent: this.distributionArea.agent,
          }
        );
        if (response) this.isAgentModal = false;
      } catch (error) {
        console.log(error);
      }
    },
    truncateText(text) {
      return truncateText(text, 10);
    },
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    tableLineBackground: {
      type: String,
      default: "transparent",
    },
    isAgents: {
      type: Boolean,
      defult: false,
    },
    distributionArea: {
      type: Object,
      rqeuired: true,
    },
  },
};
</script>
<style lang="scss">
.distribution-areas {
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  }
  .v-progress-linear__background {
    background-color: #b7b7b7 !important;
  }
  .v-progress-linear__determinate {
    border-radius: 50px;
  }
  .v-progress-circular__underlay {
    color: #656565 !important;
  }
  .v-skeleton-loader__image {
    border-radius: 20px;
    width: 320px;
    height: 320px;
  }
}
</style>
<style scoped lang="scss">
//vuetify
.v-progress-linear__content {
  strong {
    color: #ffffff !important;
    font-size: 14px;
    font-weight: 400;
  }
}
.contiainer-distubution {
  border: 1px solid $borderColor;
  background-color: v-bind(tableLineBackground);
  border-radius: 20px;
  min-width: 440px;
  padding: 20px;
  height: 100%;
  .contiainer {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
  }

  .right-side {
    border-bottom: 2px dashed $borderColor;
  }

  @include media(tablet) {
    .right-side {
      padding-bottom: 10px;
    }

    .info-wrapper {
      padding: 6px !important;
    }

    .left-side,
    .right-side {
      width: 100% !important;
      padding: 0px !important;
    }

    .right-side {
      padding-bottom: 10px !important;
      padding-left: 10px !important;
    }

    .left-side {
      padding-right: 7px !important;
    }
  }

  .left-side {
    display: flex;
    padding-right: 30px;
    gap: 20px;
    flex-direction: column;
  }
}

.contiainer-distubution:hover {
  box-shadow: 0px 5px 15px -3px rgba(0, 0, 0, 0.1);
}

@include media(tablet,smallLaptop) {
  .contiainer-distubution {
    max-width: 300px !important;
  }
}
@include media(mobile) {
  .contiainer-distubution {
    // min-width: 300px !important;
  }
}
.title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
  .icon-backgorund {
    background: $primaryBackgroundColor;
    padding: 15px;
    border-radius: 50%;
  }
}
.pressnet-wrapper {
  margin-bottom: 8px;
}
.info-wrapper {
  background: $grayBackgroundColor;
  padding: 20px;
  text-align: start;
  border-radius: 20px;
  &.hover:hover {
    color: white;
    span,
    i {
      color: white !important;
      caret-color: white !important;
    }
  }
  &.blue:hover {
    background: $ordersMainColor;
  }
  &.green:hover {
    background: $customerMainColor;
  }
}
.title-agents {
  display: flex;
  justify-content: space-between;

  .title-agents-right {
    display: flex;
    gap: 5px;
  }
  .title-agents-left {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    .edit {
      text-decoration: underline;
    }
  }
}
.progress-linear {
  background: $grayBackgroundColor;
  margin-top: 10px;
  border-radius: 50px;
}
</style>
